import Fee from '../../components/Help/Fee';

const FeePage = () => {
  return <Fee />;
};

export default FeePage;
